<app-form-element [control]="formControl" [id]="id" [label]="label" [required]="required" [twoColumns]="twoColumns">
  <div [class.invalid]="!formControl.valid">
    @for (item of value; track $index; let i = $index) {
      <div class="item">
        @if (options.length > 0 && inputType === 'select') {
          <p-select
            [(ngModel)]="item.value"
            (onChange)="update()"
            [appendTo]="'body'"
            [disabled]="formControl.disabled"
            [filter]="true"
            [filterBy]="'label'"
            [options]="options"
            [style]="{ width: '100%' }"
            appScrollIntoView></p-select>
        }
        @if (inputType === 'text') {
          <input [(ngModel)]="item.value" [disabled]="formControl.disabled" [style]="{ width: '100%' }" pInputText />
        }
        @if (inputType === 'number') {
          <p-inputNumber
            [(ngModel)]="item.value"
            [disabled]="formControl.disabled"
            [locale]="'de-CH'"
            [maxFractionDigits]="maxFractionDigits"
            [minFractionDigits]="minFractionDigits"
            [style]="{ width: '100%' }"></p-inputNumber>
        }
        <p-datepicker
          [(ngModel)]="item.from"
          (onInput)="update()"
          (onSelect)="update()"
          [appendTo]="'body'"
          [class.invalid]="!validationState[i].from"
          [disabled]="formControl.disabled"
          [maxDate]="maxDate!"
          [minDate]="minDates[i]"
          appendTo="body"
          dateFormat="dd.mm.yy"></p-datepicker>
        <span class="minus"><i class="fal fa-minus"></i></span>
        <p-datepicker
          [(ngModel)]="item.to"
          (onInput)="update()"
          (onSelect)="update()"
          [appendTo]="'body'"
          [class.invalid]="!validationState[i].to"
          [disabled]="formControl.disabled"
          [maxDate]="maxDate!"
          [minDate]="item.from"
          appendTo="body"
          dateFormat="dd.mm.yy"></p-datepicker>
        @if (!formControl.disabled) {
          <p-button
            (onClick)="add(item)"
            class="first-button"
            icon="fal fa-plus"
            iconPos="left"
            type="button"></p-button>
        }
        @if (!formControl.disabled) {
          <p-button
            (onClick)="remove(item)"
            [disabled]="item.deletable === false"
            icon="fal fa-minus"
            iconPos="left"
            type="button"></p-button>
        }
      </div>
    }
    @if (value.length === 0 && !formControl.disabled) {
      <p-button (onClick)="add()" class="first-button" icon="fal fa-plus" iconPos="left" type="button"></p-button>
    }
  </div>
</app-form-element>
